/**
 * DiffViewer — GitHub-style side-by-side diff using react-diff-viewer.
 *
 * Receives old/new markdown text from the backend and renders a
 * colored diff with line numbers, like GitHub's pull request view.
 */

import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer-continued';
import { useTranslation } from 'react-i18next';

export function DiffViewer({ diff, onBack }) {
  const { t } = useTranslation();
  const { oldValue = '', newValue = '', fromVersion, toVersion } = diff;

  const hasChanges = oldValue !== newValue;

  return (
    <div className="flex flex-col h-full">
      {/* Header */}
      <div className="flex items-center justify-between p-3 border-b border-[var(--color-border)]">
        <span className="text-sm font-medium text-[var(--color-text)]">
          {t('dataroom.diff.header', { from: fromVersion, to: toVersion })}
        </span>
        <button
          type="button"
          className="text-xs px-2 py-1 rounded border border-[var(--color-border)] hover:bg-[var(--color-accent-subtle)] text-[var(--color-text-secondary)]"
          onClick={() => onBack?.()}
        >
          {t('dataroom.diff.back')}
        </button>
      </div>

      {/* Diff content */}
      <div className="flex-1 overflow-auto text-xs">
        {!hasChanges ? (
          <div className="text-center text-[var(--color-text-muted)] py-8">
            {t('dataroom.diff.noChanges')}
          </div>
        ) : (
          <ReactDiffViewer
            oldValue={oldValue}
            newValue={newValue}
            splitView={false}
            useDarkTheme={false}
            compareMethod={DiffMethod.LINES}
            leftTitle={`v${fromVersion}`}
            rightTitle={t('dataroom.diff.currentTitle', { version: toVersion })}
            styles={{
              contentText: { fontSize: '12px', lineHeight: '1.5' },
            }}
          />
        )}
      </div>
    </div>
  );
}
